<script lang="ts">
const __DsBlock = {
	type: 'input',
	category: 'input',
	hidden: true,
}
</script>
<script setup lang="ts">
import type { InputBlockProps } from '#layers/blocks/types/input-block';
import type { GlobalSingleRelationFieldId } from '#layers/data-model/public';
import { computed } from 'vue';
import { canAssignRole, connectMemberRoles, disconnectMemberRoles } from '#layers/access/public';
import { defineBlock } from '#layers/block-engine/public';
import RelatedItemListCard from '#layers/blocks/components/Relation/RelatedItemListCard.vue';
import { PUBLIC_ROLE_ID } from '#layers/data-model/public';
import { useRelationFormField } from '#layers/forms/public';
import { useAssignmentBlock } from './use-assignment-block';

interface MonospaceRole {
	id: string;
	name: string;
}

export interface InputRoleAssignmentBlockProps extends InputBlockProps {
	fieldId?: GlobalSingleRelationFieldId;
}

const { disabled, disabledNotice, fieldId } = defineProps<InputRoleAssignmentBlockProps>();

;

const { referencedItemKey: userKey } = useRelationFormField(() => ({ disabled, disabledNotice, fieldId }));

const { cardProps } = useAssignmentBlock<MonospaceRole>({
	collectionApiName: 'MonospaceRole',
	displayCollectionName: 'MonospaceRole',
	ownerId: computed(() => userKey.value?.id),
	entitlement: canAssignRole(),
	relation: { field: 'users', ownerKey: 'userId' },
	junction: { collectionApiName: 'MonospaceUserRole', ownerKey: 'userId', targetKey: 'roleId' },
	// The engine rejects attaching the public role, so it is never offered.
	excludedIds: [PUBLIC_ROLE_ID],
	attach: ({ fetch, ids, ownerId }) => connectMemberRoles({ fetch, memberId: ownerId, roleIds: ids }),
	detach: ({ fetch, ids, ownerId }) => disconnectMemberRoles({ fetch, memberId: ownerId, roleIds: ids }),
	errorMessages: {
		attach: 'pages.settings.access.errors.attach_roles_failed',
		detach: 'pages.settings.access.errors.detach_roles_failed',
	},
});
</script>

<template>
	<RelatedItemListCard
		v-if="cardProps"
		v-bind="cardProps"
		:disabled
		:disabled-notice
	/>
</template>
